import { jsx as _jsx } from "react/jsx-runtime";
import { CardMenuItem } from "./ProfileMenuCard.components.js";
export const ProfileMenuCardMoleculeComponent = ({ label, badge, icon, payload, dataTourId, slotProps, }) => (_jsx(CardMenuItem, { onClick: payload, "data-tourid": dataTourId, ...slotProps?.cardMenuItem, slotProps: { badge, ...(icon ? { startIcon: { type: icon } } : {}) }, children: label }));
export default ProfileMenuCardMoleculeComponent;
